import McChatbotPage from "./McChatbotPage";

export {McChatbotPage}
export default McChatbotPage
